import { ChannelSort, Channel} from 'stream-chat'
import { isChatDM, isChatEmpty } from './chat'

export const chatSort: ChannelSort = [
  { pinned_at: -1, last_message_at: -1, created_at: -1, updated_at: -1 },
]

// Remove DM channels that has no messages
export const channelRenderFilterFn = (channels: Channel[]) => {
  return channels.filter(c => !(isChatDM(c) && isChatEmpty(c)))
}
